import { STORAGE_KEY } from '../constants/generic';
import { getAppObj } from './utils';
import config from '../constants/config';
import { keycloakUrlMap } from '../constants/maps';
import Keycloak from 'keycloak-js';
import { saveSsoTokens } from './tokens';

export const KEYCLOAK_STATUS = {
  AUTH: 0,
  UNAUTH: 1,
  FAIL: 2
};

export function getKeycloakUrl(env = config.env) {
  return keycloakUrlMap[env] || keycloakUrlMap.prod;
}

export function initKeycloak(settings, cb) {
  const { AUTH, UNAUTH, FAIL } = KEYCLOAK_STATUS;

  try {
    getAppObj().keycloak = new Keycloak(settings);

    // Refresh proactif : Keycloak declenche onTokenExpired des que l'access token
    // expire. On le rafraichit immediatement pour eviter qu'un appel API parte avec
    // un token expire (ce qui provoquerait un 401 -> deconnexion).
    getAppObj().keycloak.onTokenExpired = () => {
      getAppObj()
        .keycloak.updateToken(30)
        .then(() => saveSsoTokens())
        .catch(() => {});
    };

    getAppObj()
      .keycloak.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        checkLoginIframe: true,
        checkLoginIframeInterval: 10
      })
      .then((authenticated) => {
        cb(authenticated ? AUTH : UNAUTH);
      })
      .catch((e) => cb(FAIL, e));
  } catch (e) {
    cb(FAIL, e);
  }
}

export function isLoginPending() {
  return localStorage.getItem(STORAGE_KEY.LOGIN_PENDING);
}

export function setLoginPending() {
  localStorage.setItem(STORAGE_KEY.LOGIN_PENDING, true);
}

export function clearLoginPending() {
  localStorage.removeItem(STORAGE_KEY.LOGIN_PENDING);
}

export function isLogoutPending() {
  return localStorage.getItem(STORAGE_KEY.LOGOUT_PENDING);
}

export function setLogoutPending() {
  localStorage.setItem(STORAGE_KEY.LOGOUT_PENDING, true);
}

export function clearLogoutPending() {
  localStorage.removeItem(STORAGE_KEY.LOGOUT_PENDING);
}

export function getKeycloakEmail() {
  return getAppObj().keycloak?.idTokenParsed?.email;
}
